// extracted by mini-css-extract-plugin
export default {"loading":"loading__ayaxI","modalContent":"modalContent__kGiRr","content":"content__ae6BC"};